<template>
  <div>
    <b-modal v-model="modal.ver" size="xl" :title="modalTitle" hide-footer centered>
      <crear v-if="modal.paso == 0 "></crear>
      <enlazar :asociar="asociar" v-if="modal.paso == 1"></enlazar>

    </b-modal>
  </div>
</template>

<script>
  import {mapState} from "vuex"
  import crear from './crear.vue';
  import enlazar from './enlazar.vue';

  export default {
    name: "modal",
    components: {
        crear,
        enlazar
    },
    computed: {
      ...mapState('location', ['modal', 'asociar', 'moduleCreated']),
      modalTitle() {
        if (this.moduleCreated === 'childLocation') {
          return 'Crear Ubicación';
        }
        return 'Crear Ubicación Raíz';
      }
    }
  }
</script>
